import { createAction } from 'redux-actions';

export const getDocumentDetails = createAction('GET_DOCUMENT_DETAILS');
export const setDocumentsDetails = createAction('GET_DOCUMENTS_DETAILS');
export const getDocumentPath = createAction('GET_DOCUMENT_PATH');
export const getPathName = createAction('GET_PATH_NAME');
export const getReadDocument = createAction('GET_READ_DOCUMENT');
export const documentFailure = createAction('DOCUMENT_FAILURE');
export const documentSuccessUpload = createAction('DOCUMENT_SUCCESS_UPLOAD');
export const setUploadDocuments = createAction('SET_UPLOAD_DOCUMENTS');
export const setCollapse = createAction('SET_COLLAPSE');
export const setSelectedContacts = createAction('SET_SELECTED_CONTACTS');
export const getDocumentValue = createAction('GET_DOCUMENT_VALUE');
export const setModifyContact = createAction('SET_MODIFY_CONTACT');
export const setNavigationPane = createAction('SET_NAVIGATION_PANE');
export const refreshPath = createAction('REFRESH_PATH');
export const getActiveDocument = createAction('GET_ACTIVE_DOCUMENT');
export const setSelectNewDocument = createAction('SET_SELECT_NEW_DOCUMENT');
export const goBackClientDocument = createAction('GO_BACK_CLIENT_DOCUMENT');
export const setClientDocument = createAction('SET_CLIENT_DOCUMENT');
export const setRefreshUpload = createAction('SET_REFRESH_UPLOAD');
export const setEmailToContactsOnPublish = createAction('SET_EMAIL_TO_CONTACTS_ON_PUBLISH');
export const setDocumentsView = createAction('SET_DOCUMENTS_VIEW');
